export default __webpack_public_path__ + "static/media/Division_09.c26dd815.png";